module.exports = __webpack_public_path__ + "media/components/assets/img/bg/booking-airport-35a8af0d4c33a3cc3831493765eb3581.svg";